import { render, staticRenderFns } from "./displayInfo.vue?vue&type=template&id=821b4290&scoped=true"
import script from "./displayInfo.vue?vue&type=script&lang=js"
export * from "./displayInfo.vue?vue&type=script&lang=js"
import style0 from "./displayInfo.vue?vue&type=style&index=0&id=821b4290&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821b4290",
  null
  
)

export default component.exports